/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ChangeDetectionStrategy, Component, OnInit} from "@angular/core";
import {SwUpdate} from "@angular/service-worker";
import {AppEnvironmentConfig} from "@app/app.environment.config";
import {SIDE_MENU_MAIN} from "@app/models/constants/side-menu.constants";
import {MenuEntries} from "@app/models/menu-entries";
import {Patient} from "@app/modules/doctor-panel/models/patient";
import {CommonActions} from "@app/store/common/common.actions";
import {CommonState} from "@app/store/common/common.state";
import {environment} from "@env/environment";
import {MenuController} from "@ionic/angular";
import {AppMenuService} from "@modules/base/services/app-menu.service";
import {Select, Store} from "@ngxs/store";
import {PersonalData} from "@trec/api/personal-data";
import {SessionManagerStructureAssociation} from "@trec/api/session-manager";
import {Observable} from "rxjs";

@Component({
  selector: "app-menu-lateral",
  templateUrl: "./menu-lateral.component.html",
  styleUrls: ["./menu-lateral.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MenuLateralComponent implements OnInit {
  @Select(CommonState.isAuthenticated) isAuthenticated$: Observable<boolean | null>;
  @Select(CommonState.loggedUserPersonalData)
  currentUserPersonalData$: Observable<PersonalData | null>;
  @Select(CommonState.loggedUserStructuresExcludeSelf) structures$: Observable<
    SessionManagerStructureAssociation[]
  >;
  @Select(CommonState.patient) patient$: Observable<Patient | null>;
  @Select(CommonState.userId) userId$: Observable<string | null>;
  @Select(CommonState.isPhysician) isPhysician$: Observable<boolean | undefined>;
  @Select(CommonState.currentStructureId) currentStructureId$: Observable<string | null>;

  menuEntries: MenuEntries;
  srcLogo: any;
  readonly isDevEnv = !environment.production;
  readonly APP_VERSION = environment.version;

  /**
   * Function used to sort entries "as they are listed".
   */
  entrySortOrder = (a, _) => a;

  constructor(
    private store: Store,
    private menuService: AppMenuService,
    public swUpdate: SwUpdate,
    private menuCtrl: MenuController
  ) { }

  ngOnInit() {
    this.srcLogo = AppEnvironmentConfig.srcLogo;
    this.menuEntries = this.menuService.getMenu();
  }

  /**
   * Change the current structure id saved in store for the logged user.
   */
  onStructureChange(event: string) {
    const structureId: string = event;
    // const structureId: string = event.detail.value;
    this.store.select(CommonState.loggedUserStructures).subscribe((strucs) => {
      for (let i = 0; i < strucs!.length; i++) {

        if (strucs![i].structureId === structureId) {

          const structureContext = strucs![i].context;
          this.store.dispatch(new CommonActions.ChangeCurrentStructureId({structureId, structureContext}));
          break;

        }

      };

    });

  }

  onCheckUpdates() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
    }
  }

  onClose() {
    this.menuCtrl.close(SIDE_MENU_MAIN);
  }
}
